import React, {
  useEffect,
  useState,
  useRef,
  forwardRef,
  useImperativeHandle,
  useMemo,
} from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import styles from "../BusinessListing/BusinessListing.module.css";
import {
  addKnowledgeBaseSources,
  API_BASE_URL,
  createKnowledgeBaseWithDetails,
  fetchAvailablePhoneNumberByCountry,
  getPhoneNumberAccordingToCountry,
  listSiteMap,
  validateWebsite,
} from "../../Store/apiStore";
import PopUp from "../Popup/Popup";
import Loader from "../Loader/Loader";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import { useAgentCreator } from "../../hooks/useAgentCreator";
import getKnowledgeBaseName from "../../utils/getKnowledgeBaseName";
import decodeToken from "../../lib/decodeToken";
import useOnboardingTracker from "../../hooks/useOnboardingTracker";
import GoogleAddressInputWithDropdown from "../GoogleAddressInputWithDropdown/GoogleAddressInputWithDropdown";
import filterCompanyPages from "../../utils/companyKeyboards";
const MAX_SELECTED_SITEMAP_URLS = 100;
const DEFAULT_HOURS_FALLBACK = [
  "Monday: 9:00 AM – 6:00 PM",
  "Tuesday: 9:00 AM – 6:00 PM",
  "Wednesday: 9:00 AM – 6:00 PM",
  "Thursday: 9:00 AM – 6:00 PM",
  "Friday: 9:00 AM – 6:00 PM",
  "Saturday: 9:00 AM – 6:00 PM",
  "Sunday: Closed",
];

const getDefaultHoursString = () => DEFAULT_HOURS_FALLBACK.join(" | ");

const hasValidGmbHours = (hours) => {
  if (!hours) return false;
  if (Array.isArray(hours)) return hours.filter(Boolean).length > 0;
  if (typeof hours === "string") return hours.trim().length > 0;
  return false;
};

const BusinessListing = forwardRef(
  (
    {
      onNext,
      onBack,
      onValidationError,
      onSuccess,
      onFailed,
      setLoading,
      onStepChange,
      loading,
      isSiteMapView,
    },
    ref
  ) => {
    const [businessName, setBusinessName] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [address, setAddress] = useState("");
    const [email, setEmail] = useState("");
    const [aboutBussiness, setAboutBusiness] = useState("");
    const [popupMessage, setPopupMessage] = useState("");
    const [popupType, setPopupType] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const token = localStorage.getItem("token");
    const decodeTokenData = decodeToken(token);
    const userId = decodeTokenData?.id;
    const agentCode = sessionStorage.getItem("AgentCode");
    const navigate = useNavigate();
    const EditingMode1 = localStorage.getItem("UpdationMode");
    const [selectedCountry, setSelectedCountry] = useState("us");
    const [street_number, setStreet_number] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");
    const [postal_code, setPostal_code] = useState("");
    const [country_code, setCountry_code] = useState("");
    const [state_code, setState_code] = useState("");
    const listRef = useRef(null);
    const setHasFetched = true;
    const isIphone = /iPhone|iPod/i.test(navigator.userAgent);
    const { steps, trackStep } = useOnboardingTracker();
    const [website, setWebsite] = useState("");
    const [hasNoWebsite, setHasNoWebsite] = useState(false);
    const [isValidWebsite, setIsValidWebsite] = useState(null);
    const [validateLoading, setValidateLoading] = useState(false);
    const storedDetails = sessionStorage.getItem("placeDetailsExtract");

    const getDomain = (u = "") =>
      u
        .replace(/^https?:\/\//i, "")
        .replace(/^www\./i, "")
        .split("/")[0]
        .toLowerCase();

    const isUrlEffectivelyEmpty = (val = "") => {
      const v = val.trim().toLowerCase();
      return v === "" || v === "https://" || v === "http://";
    };

    const sanitizeDescription = (str = "") => {
      let v = str;
      v = v.replace(
        /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF])/g,
        ""
      );
      v = v.replace(/[^a-zA-Z0-9 .,?' -]/g, "");
      v = v.replace(/\s+/g, " ");
      v = v.trimStart();

      return v;
    };

    const normalizeSelected = (selected) => {
      if (!Array.isArray(selected)) return [];

      if (!selected.length) return [];

      const first = selected[0];

      if (typeof first === "string") {
        // old format
        return selected.map((url) => ({ url, checkedStatus: true }));
      }

      if (typeof first === "object" && first !== null) {
        // new format
        return selected.map((item) => ({
          url: item.url,
          checkedStatus: Boolean(item.checkedStatus),
        }));
      }

      return [];
    };

    const safeParse = (raw) => {
      try {
        return normalizeSelected(JSON.parse(raw || "[]"));
      } catch {
        return [];
      }
    };

    const getCheckedCount = (arr) =>
      (arr || []).filter((i) => i.checkedStatus).length;

    const getInitialSelectedSiteMapUrls = () => {
      try {
        const rawMain = sessionStorage.getItem("selectedSiteMapUrls");
        const rawBackup = sessionStorage.getItem("selectedSiteMapUrls_backup");
        const main = safeParse(rawMain);
        const backup = safeParse(rawBackup);
        if (backup.length) return backup;
        return main;
      } catch (e) {
        console.error("Error reading sitemap selections", e);
        return [];
      }
    };

    const [storedSelected, setStoredSelected] = useState(
      getInitialSelectedSiteMapUrls
    );

    const [filteredPages, setFilteredPages] = useState([]);
    const [refreshKey, setRefreshKey] = useState(0);

    const typingTimer = useRef(null);
    const { handleCreateAgent } = useAgentCreator({
      stepValidator: () => "BusinessListing",
      setLoading,
      setPopupMessage,
      setPopupType,
      setShowPopup,
      navigate,
      setHasFetched,
    });
    const containsSpecialChars = (str) => /[!@#$%^&*(),.?":{}|<>]/.test(str);
    const containsEmoji = (str) =>
      /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF])/g.test(
        str
      );
    const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

    useEffect(() => {
      const storedDetails = sessionStorage.getItem("placeDetailsExtract");
      if (storedDetails) {
        const details = JSON.parse(storedDetails);
        setBusinessName(details?.businessName || "");
        setPhoneNumber(details.internationalPhone || details?.phone);
        setAddress(details?.address || "");
        setEmail(details?.email || "");
        setAboutBusiness(
          details?.aboutBusiness || details?.aboutBussiness || ""
        );
      }
      if (EditingMode1 != "ON") {
        const details = JSON.parse(storedDetails);
        setAboutBusiness(
          details?.aboutBusiness || details?.aboutBussiness || ""
        );
      }
    }, []);

    const handleInputChange = (field, value) => {
      const currentData = JSON.parse(
        sessionStorage.getItem("placeDetailsExtract") || "{}"
      );
      const updatedData = { ...currentData, [field]: value };
      sessionStorage.setItem(
        "placeDetailsExtract",
        JSON.stringify(updatedData)
      );

      switch (field) {
        case "businessName":
          setBusinessName(value);
          break;
        case "phone":
        case "internationalPhone":
          const formattedPhone = value.startsWith("+") ? value : `+${value}`;
          setPhoneNumber(formattedPhone);
          break;

        case "address":
          setAddress(value);
          break;
        case "email":
          setEmail(value);
          break;
        case "aboutBussiness":
          setAboutBusiness(value);
          break;
        default:
          break;
      }
    };
    const formatLabel = (str) =>
      str
        .replace(/([A-Z])/g, " $1")
        .replace(/^./, (s) => s.toUpperCase())
        .replace(/_/g, " ");
    const aboutBusinessForm = JSON.parse(
      sessionStorage.getItem("aboutBusinessForm") || "{}"
    );
    const handleSubmit = async (e) => {
      if (e) e.preventDefault();
      if (loading) return;
      try {
        setLoading(true);
        const phoneNumberObj = parsePhoneNumberFromString(
          phoneNumber,
          selectedCountry
        );

        if (!phoneNumberObj || !phoneNumberObj.isValid()) {
          setLoading(false);
          setPopupType("failed");
          setPopupMessage("Please enter a valid phone number.");
          setShowPopup(true);

          return;
        }
        const placeDetails = JSON.parse(
          sessionStorage.getItem("placeDetailsExtract") || "{}"
        );
        const business = JSON.parse(
          sessionStorage.getItem("businessDetails") || "{}"
        );
        const sessionBusinessiD = JSON.parse(sessionStorage.getItem("bId"));
        const knowledgeBaseId = sessionStorage.getItem("knowledgeBaseId");
        const displayBusinessName = sessionStorage.getItem(
          "displayBusinessName"
        );
        const packageName = sessionStorage.getItem("package") || "Free";
        const stepEditingMode = localStorage.getItem("UpdationModeStepWise");
        const EditingMode = localStorage.getItem("UpdationMode");
        const agentCount = 0;
        if (!businessName || !address || !phoneNumber) {
          setPopupType("failed");
          setPopupMessage("Please fill all required fields.");
          setShowPopup(true);

          return;
        }
        const packageMap = {
          Free: 1,
          Starter: 2,
          Scaler: 3,
          Growth: 4,
          Corporate: 5,
          Enterprise: 6,
        };
        const packageValue = packageMap[packageName] || 1;
        const knowledgeBaseName = await getKnowledgeBaseName(
          business,
          userId,
          packageValue,
          agentCode
        );
        //extractAddressFields
        const extractAddressFields = (addressComponents) => {
          const getComponent = (
            primaryType,
            fallbackType = null,
            useShort = false
          ) => {
            const comp = addressComponents.find(
              (c) =>
                c.types.includes(primaryType) ||
                (fallbackType && c.types.includes(fallbackType))
            );
            return comp ? (useShort ? comp.short_name : comp.long_name) : "";
          };

          return {
            city: getComponent("locality", "sublocality_level_1"),
            state: getComponent("administrative_area_level_1"),
            state_code: getComponent("administrative_area_level_1", null, true),
            country: getComponent("country"),
            country_code: getComponent("country", null, true),
            postal_code: getComponent("postal_code"),
            street_number: getComponent("street_number"),
            route: getComponent("route"),
          };
        };

        // After extracting address fields, set them in the state and session storage
        const addressFields = extractAddressFields(
          placeDetails?.address_components || []
        );
        // Update the state
        setCity(addressFields.city);
        setState(addressFields.state); // Ensure the state is updated here
        setCountry(addressFields.country);
        setPostal_code(addressFields.postal_code);
        setStreet_number(addressFields.street_number);
        setCountry_code(addressFields.country_code);
        setState_code(addressFields.state_code);

        const finalHours = hasValidGmbHours(placeDetails?.hours)
          ? (Array.isArray(placeDetails.hours)
            ? placeDetails.hours.join(" | ")
            : String(placeDetails.hours))
          : getDefaultHoursString();

        const updatedPlaceDetails = {
          ...placeDetails,
          businessName: businessName || placeDetails?.businessName,
          phone: phoneNumber,
          address: address,
          email: email,
          aboutBussiness: aboutBussiness,
          hours: finalHours,
          city: addressFields.city,
          state: addressFields.state,
          country: addressFields.country,
          postal_code: addressFields.postal_code,
          street_number: addressFields.street_number,
          country_code: addressFields.country_code,
          state_code: addressFields.state_code,
        };

        sessionStorage.setItem(
          "placeDetailsExtract",
          JSON.stringify(updatedPlaceDetails)
        );

        //Get Details From GMB
        const businessData = {
          businessName: businessName || placeDetails?.businessName || "",
          address: placeDetails?.address || address,
          phone: placeDetails?.phone || phoneNumber,
          website: placeDetails?.website || aboutBusinessForm.businessUrl,
          rating: placeDetails?.rating || "",
          totalRatings: placeDetails?.totalRatings || "",
          hours: finalHours,
          businessStatus: placeDetails?.businessStatus || "",
          categories: Array.isArray(placeDetails?.categories)
            ? placeDetails.categories.join(", ")
            : "",
          email: email,
          aboutBussiness: aboutBussiness,
          city: addressFields?.city,
          state: addressFields?.state,
          country: addressFields?.country,
          postal_code: addressFields?.postal_code,
          street_number: addressFields?.street_number,
          country_code: addressFields?.country_code,
          state_code: addressFields?.state_code,
          // setCountry_code()
          // setCountry_code()
        };
        const placeDetailsForKBT = JSON.parse(
          sessionStorage.getItem("placeDetailsExtract") || "{}"
        );
        const readableDetails = Object?.entries(placeDetailsForKBT)
          .map(
            ([key, value]) =>
              `${formatLabel(key)}: ${Array.isArray(value) ? value.join(", ") : value || "N/A"
              }`
          )
          .join("\n");

        const knowledgeBaseText = [
          {
            title: "Business Details",
            text: readableDetails,
          },
        ];
        const mergedUrls = [];
        const rawUrl = aboutBusinessForm.businessUrl?.trim();
        const sessionSelectedSiteMapUrls = JSON.parse(
          sessionStorage.getItem("selectedSiteMapUrls") || "[]"
        );

        // Count only checked/selected URLs
        const selectedUrlCount = sessionSelectedSiteMapUrls.filter(
          (item) => item.checkedStatus
        ).length;

        if (selectedUrlCount > MAX_SELECTED_SITEMAP_URLS) {
          setPopupType("failed");
          setPopupMessage(
            `You can select only ${MAX_SELECTED_SITEMAP_URLS} pages from sitemap. You have selected ${selectedUrlCount}.`
          );
          setShowPopup(true);
          setLoading(false);
          return;
        }

        if (sessionSelectedSiteMapUrls.length > 0) {
          // Push all selected (checkedStatus: true)
          mergedUrls.push(
            ...sessionSelectedSiteMapUrls
              .filter((item) => item.checkedStatus)
              .map((item) => item.url)
          );
        } else {
          // If no sitemap, at least push rawUrl
          if (rawUrl) mergedUrls.push(rawUrl);
        }

        if (aboutBusinessForm?.googleListing) {
          mergedUrls.push(aboutBusinessForm?.googleListing);
        }
        // const mergedUrls = rawUrl ? [rawUrl] : [];
        const formData = new FormData();
        const formData2 = new FormData();
        const formData3 = new FormData();
        if (mergedUrls.length > 0) {
          formData.append("knowledge_base_urls", JSON.stringify(mergedUrls));
          formData3.append("knowledge_base_urls", JSON.stringify(mergedUrls));
        }
        formData.append("knowledge_base_name", knowledgeBaseName);
        formData.append("enable_auto_refresh", "true");
        formData.append(
          "knowledge_base_texts",
          JSON.stringify(knowledgeBaseText)
        );
        formData2.append("knowledge_base_texts", JSON.stringify(businessData));
        //Crate Knowledge Base
        formData2.append("googleUrl", aboutBusinessForm.googleListing);
        formData2.append(
          "webUrl",
          (aboutBusinessForm?.businessUrl || "").trim()
        );

        formData2.append("aboutBusiness", aboutBussiness);
        formData2.append("additionalInstruction", aboutBusinessForm.note || "");
        formData2.append("agentId", localStorage.getItem("agent_id"));
        formData2.append("googleBusinessName", displayBusinessName || "");
        formData2.append("address1", businessData.address);
        formData2.append("businessEmail", email);
        formData2.append("city", businessData?.city || city);
        formData2.append("state", businessData?.state || state);
        formData2.append(
          "scrapedUrls",
          JSON.stringify(sessionSelectedSiteMapUrls) || []
        );
        formData2.append("state_code", businessData?.state_code || state_code);
        formData2.append(
          "country_code",
          businessData?.country_code || country_code
        );
        formData2.append("country", businessData?.country || country);
        formData2.append(
          "postal_code",
          businessData?.postal_code || postal_code
        );
        formData2.append(
          "street_number",
          businessData?.street_number || street_number
        );
        formData2.append(
          "businessName",
          placeDetails?.businessName || businessName
        );
        formData2.append("phoneNumber", phoneNumber);
        formData2.append("isGoogleListing", aboutBusinessForm.noGoogleListing);
        formData2.append("isWebsiteUrl", aboutBusinessForm.noBusinessWebsite);
        formData3.append(
          "knowledge_base_texts",
          JSON.stringify(knowledgeBaseText)
        );
        let knowledge_Base_ID = knowledgeBaseId;

        if (
          knowledge_Base_ID !== null &&
          knowledge_Base_ID !== undefined &&
          knowledge_Base_ID !== "null" &&
          knowledge_Base_ID !== "undefined" &&
          knowledge_Base_ID !== ""
        ) {
          const response = await addKnowledgeBaseSources(token, knowledge_Base_ID, formData3);
          formData2.append("knowledge_base_id", response?.data?.knowledge_base_id);
        } else {


          // const response = await axios.post(
          //   "https://api.retellai.com/create-knowledge-base",
          //   formData,
          //   {
          //     headers: {
          //       Authorization: `Bearer ${process.env.REACT_APP_API_RETELL_API}`,
          //     },
          //   }
          // );
          const response = await createKnowledgeBaseWithDetails(token, formData);
          const kbId = response?.data?.knowledge_base_id;
          const kbName = response?.data?.knowledge_base_name;

          formData2.append("knowledge_base_id", kbId);
          formData2.append("knowledge_base_name", kbName || knowledgeBaseName);

          knowledge_Base_ID = kbId;

          if (kbId) {
            sessionStorage.setItem("knowledgeBaseId", kbId);
          } else {
            console.error("KB ID missing in response:", response);
          }

        }

        await axios.patch(
          `${API_BASE_URL}/businessDetails/updateKnowledeBase/${sessionBusinessiD}`,
          formData2,
          {
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_RETELL_API}`,
              "Content-Type": "multipart/form-data",
            },
          }
        );
        //getNumberAccording to Country
        if (stepEditingMode === "ON" && knowledge_Base_ID) {
          handleCreateAgent();
        }
        if (stepEditingMode !== "ON") {
          if (onSuccess) {
            onSuccess({
              message: "Knowledge base created successfully!",
            });
            setTimeout(() => {
              onStepChange?.(5);
            }, 2000);
            const resolvedKnowledgeBaseId =
              knowledge_Base_ID ||
              sessionStorage.getItem("knowledgeBaseId") ||
              null;

            trackStep({
              stepName: "business_details",
              stepNo: 4,
              screenName: "Business details",
              email: localStorage.getItem("userEmail"),
              userId: decodeToken(localStorage.getItem("token"))?.id || null,
              data: {
                knowledgeBaseId: resolvedKnowledgeBaseId,
                businessData: businessData,
              },
            });

            // First attempt: Country + State + City
            await getPhoneNumberAccordingToCountry(
              token,
              businessData?.country_code || country_code,
              "",
              ""
            );
          }
        } else {
          setShowPopup(true);
          setPopupType("success");
          setPopupMessage("Knowledge base updated successfully!");
          setTimeout(() => {
            navigate("/fast-agent-detail", {
              state: {
                agentId: localStorage.getItem("agent_id"),
                bussinesId: sessionBusinessiD,
              },
            });
          }, 1000);
        }
      } catch (error) {
        // console.log(error);

        if (error?.response?.status === 422) {
          if (onFailed) {
            onFailed({
              message: "Knowledge base is currently updating. Try again later.",
            });
          }
        } else {
          if (onFailed) {
            onFailed({
              message: "Knowledge base is currently updating. Try again later.",
            });
          }
        }
      } finally {
        setLoading(false);
      }
    };

    useImperativeHandle(ref, () => ({
      validate: () => {
        let hasError = false;
        const urlEmpty = isUrlEffectivelyEmpty(website);
        const phoneNumberObj = parsePhoneNumberFromString(
          phoneNumber,
          selectedCountry
        );
        try {
          const sessionSelectedSiteMapUrls = JSON.parse(
            sessionStorage.getItem("selectedSiteMapUrls") || "[]"
          );
          const selectedUrlCount = sessionSelectedSiteMapUrls.filter(
            (item) => item.checkedStatus
          ).length;

          if (selectedUrlCount > MAX_SELECTED_SITEMAP_URLS) {
            hasError = true;
            onValidationError?.({
              type: "failed",
              message: `You can select only ${MAX_SELECTED_SITEMAP_URLS} pages from sitemap. You have selected ${selectedUrlCount}.`,
            });
          }
        } catch (e) {
          console.error("Error checking selected sitemap URLs", e);
        }
        if (validateLoading) {
          hasError = true;
          onValidationError?.({
            type: "failed",
            message: "Please wait... Website is still validating.",
          });
          return false;
        }
        if (!businessName.trim()) {
          hasError = true;
          onValidationError?.({
            type: "failed",
            message: "Please enter the business name.",
          });
        } else if (containsEmoji(businessName)) {
          hasError = true;
          onValidationError?.({
            type: "failed",
            message:
              "Business name cannot contain special characters or emojis.",
          });
        } else if (!address.trim()) {
          hasError = true;
          onValidationError?.({
            type: "failed",
            message: "Please enter the business address.",
          });
        } else if (containsEmoji(address)) {
          hasError = true;
          onValidationError?.({
            type: "failed",
            message: "Address cannot contain emojis.",
          });
        } else if (!phoneNumber.trim()) {
          hasError = true;
          onValidationError?.({
            type: "failed",
            message: "Please enter a valid phone number.",
          });
        } else if (!phoneNumberObj || !phoneNumberObj.isValid()) {
          hasError = true;
          onValidationError?.({
            type: "failed",
            message: "Please enter a valid phone number.",
          });
        } else if (
          containsSpecialChars(phoneNumber) ||
          containsEmoji(phoneNumber)
        ) {
          hasError = true;
          onValidationError?.({
            type: "failed",
            message:
              "Phone number cannot contain special characters or emojis.",
          });
        } else if (email.trim() && !isValidEmail(email)) {
          hasError = true;
          onValidationError?.({
            type: "failed",
            message: "Please enter a valid email address.",
          });
        } else if (aboutBussiness.trim() && containsEmoji(aboutBussiness)) {
          hasError = true;
          onValidationError?.({
            type: "failed",
            message:
              "About Business cannot contain special characters or emojis.",
          });
        } else if (!hasNoWebsite && urlEmpty) {
          hasError = true;
          onValidationError?.({
            type: "failed",
            message:
              'Please enter your website URL or check "I do not have Business website".',
          });
        } else if (!hasNoWebsite && !urlEmpty && isValidWebsite !== true) {
          hasError = true;
          onValidationError?.({
            type: "failed",
            message:
              'Please enter a valid website URL or check "I do not have Business websitee".',
          });
        }
        return !hasError;
      },
      save: async () => {
        handleSubmit();
      },
    }));

    //initAddressAutocomplete
    const initAddressAutocomplete = () => {
      const autocomplete = new window.google.maps.places.Autocomplete(
        document.getElementById("google-address-autocomplete"),
        //Fetch Only location
        //google-address-autocomplete
        {
          types: ["geocode"],
          fields: [
            "address_components",
            "formatted_address",
            "geometry",
            "url",
          ],
        }
      );
      autocomplete.addListener("place_changed", () => {
        const place = autocomplete.getPlace();

        if (place.formatted_address) {
          const addressComponents = place.address_components || [];
          setAddress(place.formatted_address);
          extractAndStoreAddressComponents(place.address_components);

          // Update sessionStorage
          const currentDetails = JSON.parse(
            sessionStorage.getItem("placeDetailsExtract") || "{}"
          );
          const updatedDetails = {
            ...currentDetails,
            address: place.formatted_address,
            address_components: addressComponents,
          };
          sessionStorage.setItem(
            "placeDetailsExtract",
            JSON.stringify(updatedDetails)
          );
        }
      });
    };
    //extractAndStoreAddressComponents
    const extractAndStoreAddressComponents = (components) => {
      const getComponent = (type) =>
        components.find((c) => c.types.includes(type))?.long_name || "";
      const addressDetails = {
        street_number: getComponent("street_number"),
        route: getComponent("route"),
        city: getComponent("locality") || getComponent("sublocality_level_1"),
        state: getComponent("administrative_area_level_1"),
        country: getComponent("country"),
        postal_code: getComponent("postal_code"),
      };
    };
    const normalizeAndValidateUrl = (url) => {
      if (!url) return "";

      // Trim whitespace
      url = url.trim();

      // Remove duplicate https:// or http:// at the start
      url = url.replace(/^(https?:\/\/)+/, "https://");

      return url;
    };
    const handleWebsiteChange = (e) => {
      let input = e.target.value || "";
      if (!input.includes("https://")) {
        input = "https://";
      }
      let domainPart = input.replace(/^https:\/\//i, "");
      if (domainPart === "" && input === "https://") {
        domainPart = "";
      }
      const finalUrl = domainPart ? `https://${domainPart}` : "https://";
      setWebsite(finalUrl);
      const cleanUrl = domainPart
        ? `https://${domainPart.replace(/^www\./i, "")}`
        : "";
      const aboutForm = JSON.parse(
        sessionStorage.getItem("aboutBusinessForm") || "{}"
      );
      const prevUrl = aboutForm.businessUrl || "";
      if (!domainPart || domainPart.length < 3 || !domainPart.includes(".")) {
        setIsValidWebsite(null);
        setFilteredPages([]);
        sessionStorage.removeItem("urls");
        // sessionStorage.removeItem("selectedSiteMapUrls");
        sessionStorage.removeItem("websiteValidatedUrl");
        sessionStorage.setItem("viewSiteMap", false);

        delete aboutForm.businessUrl;
        delete aboutForm.noBusinessWebsite;
        sessionStorage.setItem("aboutBusinessForm", JSON.stringify(aboutForm));
        sessionStorage.removeItem("businessUrl");
        return;
      }
      if (cleanUrl) {
        aboutForm.businessUrl = cleanUrl;
        delete aboutForm.noBusinessWebsite;
      } else {
        delete aboutForm.businessUrl;
      }

      sessionStorage.setItem("aboutBusinessForm", JSON.stringify(aboutForm));
      sessionStorage.setItem("businessUrl", cleanUrl);

      // Validation sirf jab domain jaisa lage
      if (!domainPart || domainPart.length < 3 || !domainPart.includes("."))
        return;

      if (typingTimer.current) clearTimeout(typingTimer.current);

      typingTimer.current = setTimeout(() => {
        const prevDomain = getDomain(prevUrl);
        const nextDomain = getDomain(cleanUrl);
        const domainChanged =
          prevDomain && nextDomain && prevDomain !== nextDomain;

        if (domainChanged) {
          sessionStorage.removeItem("websiteValidatedUrl");
          sessionStorage.removeItem("selectedSiteMapUrls");
          sessionStorage.removeItem("selectedSiteMapUrls_backup");
          setIsValidWebsite(null);
        }

        validateAndFetchSiteMap(cleanUrl, aboutForm, {
          preserveSelection: !domainChanged,
        });
      }, 800);
    };
    const handleOpenSiteMap = () => {
      const latestSelected = getInitialSelectedSiteMapUrls();
      setStoredSelected(latestSelected);

      isSiteMapView({
        urls: filteredPages,
        selected: latestSelected,
        addOnUrl: website,
      });
    };
    const handleWebsiteCheckbox = (e) => {
      const checked = e.target.checked;
      setHasNoWebsite(checked);

      const data = JSON.parse(
        sessionStorage.getItem("aboutBusinessForm") || "{}"
      );

      if (checked) {
        data.noBusinessWebsite = true;
        delete data.businessUrl;
        setWebsite("");
        setIsValidWebsite(null);
        sessionStorage.removeItem("businessUrl");
      } else {
        delete data.noBusinessWebsite;
      }

      sessionStorage.setItem("aboutBusinessForm", JSON.stringify(data));
    };

    //initAddressAutocomplete
    useEffect(() => {
      const interval = setInterval(() => {
        if (window.google?.maps?.places) {
          const input = document.getElementById("google-address-autocomplete");
          if (input) {
            initAddressAutocomplete();
            clearInterval(interval);
          }
        }
      }, 300);
    }, []);
    const scrollListIntoView = () => {
      if (listRef.current) {
        listRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    };

    useEffect(() => {
      const storedForm = JSON.parse(
        sessionStorage.getItem("aboutBusinessForm") || "{}"
      );
      setHasNoWebsite(!!storedForm.noBusinessWebsite);
      if (storedForm.noGoogleListing === true) {
        setWebsite("");
        setIsValidWebsite(null);
        sessionStorage.removeItem("businessUrl");
        return;
      }
      if (storedForm.noBusinessWebsite === true) {
        setWebsite("");
        setIsValidWebsite(null);
        sessionStorage.removeItem("businessUrl");
        return;
      }

      const fallbackBusinessUrl = sessionStorage.getItem("businessUrl") || "";
      const validatedUrl = sessionStorage.getItem("websiteValidatedUrl") || "";
      const existingUrl = storedForm.businessUrl || fallbackBusinessUrl;

      if (existingUrl) {
        const url = normalizeAndValidateUrl(existingUrl);
        setWebsite(url);

        if (validatedUrl === url) setIsValidWebsite(true);
        else
          validateAndFetchSiteMap(url, storedForm, { preserveSelection: true });
      } else {
        setWebsite("");
        setIsValidWebsite(null);
      }
    }, []);

    const validateAndFetchSiteMap = async (
      fullUrl,
      aboutFormFromChange = null,
      options = {}
    ) => {
      const { preserveSelection = false } = options;
      if (!fullUrl || typeof fullUrl !== "string") return;
      let url = fullUrl.trim();
      if (!/^https?:\/\//i.test(url)) {
        url = "https://" + url;
      }
      const domainPart = url.replace(/^https?:\/\//i, "");
      if (!domainPart) return;
      if (domainPart.length < 3 || !domainPart.includes(".")) return;
      if (!preserveSelection) {
        sessionStorage.removeItem("selectedSiteMapUrls");
      }

      fullUrl = "https://" + domainPart.replace(/^www\./i, "");
      setValidateLoading(true);

      try {
        const result = await validateWebsite(fullUrl);
        setIsValidWebsite(result?.valid || false);

        if (result?.valid) {
          let finalUrl = fullUrl;
          let aboutForm =
            aboutFormFromChange ||
            JSON.parse(sessionStorage.getItem("aboutBusinessForm") || "{}");

          // redirect handle
          if (result.finalUrl && result.finalUrl !== fullUrl) {
            let normalized = result.finalUrl.replace(/^https?:\/\//, "");
            finalUrl = "https://" + normalized;

            setWebsite(finalUrl);
            aboutForm.businessUrl = finalUrl;
            sessionStorage.setItem(
              "aboutBusinessForm",
              JSON.stringify(aboutForm)
            );
            sessionStorage.setItem("businessUrl", finalUrl);
          }

          const res = await listSiteMap(finalUrl);
          const urls = res.urls || [];
          if (!urls.includes(finalUrl)) urls.unshift(finalUrl);

          sessionStorage.setItem("urls", JSON.stringify(urls));

          if (!preserveSelection) {
            sessionStorage.removeItem("selectedSiteMapUrls");
            sessionStorage.removeItem("selectedSiteMapUrls_backup");
            setStoredSelected([]);
          }

          const pages = await filterCompanyPages(urls);
          setFilteredPages(pages);
          sessionStorage.setItem("websiteValidatedUrl", finalUrl);
          sessionStorage.setItem("viewSiteMap", true);
          // ✅ Ensure default 10 selection exists even before opening modal
          try {
            const raw =
              sessionStorage.getItem("selectedSiteMapUrls_backup") ||
              sessionStorage.getItem("selectedSiteMapUrls");

            const existing = raw ? safeParse(raw) : [];
            const checkedCount = existing.filter((i) => i.checkedStatus).length;

            // Only set default if nothing is selected already
            if (checkedCount === 0) {
              const DEFAULT_LIMIT = 10;
              const baseList = (pages && pages.length ? pages : urls) || [];

              const defaultSelected = baseList.map((u, idx) => ({
                url: u,
                checkedStatus: idx < DEFAULT_LIMIT,
              }));

              sessionStorage.setItem(
                "selectedSiteMapUrls",
                JSON.stringify(defaultSelected)
              );
              sessionStorage.setItem(
                "selectedSiteMapUrls_backup",
                JSON.stringify(defaultSelected)
              );

              // ✅ Update state so count shows immediately
              setStoredSelected(defaultSelected);

              // optional: sync any listeners
              window.dispatchEvent(new Event("sitemapSelectionUpdated"));
            } else {
              // keep state in sync if selection already exists
              setStoredSelected(existing);
            }
          } catch (e) {
            console.error("Error setting default sitemap selection", e);
          }
        } else {
          setIsValidWebsite(false);

          // add cleanup
          setFilteredPages([]);
          sessionStorage.removeItem("urls");
          // sessionStorage.removeItem("selectedSiteMapUrls");
          sessionStorage.setItem("viewSiteMap", false);

          return;
        }
      } catch (err) {
        console.error("URL Validation Error: ", err);
        setIsValidWebsite(false);

        // NEW: Clear old sitemap data
        setFilteredPages([]);
        sessionStorage.removeItem("urls");
        // sessionStorage.removeItem("selectedSiteMapUrls");

        // NEW: Flag reset so UI hide karta rahe
        sessionStorage.setItem("websiteValidatedUrl", "");
        sessionStorage.setItem("viewSiteMap", false);
      } finally {
        setValidateLoading(false);
      }
    };

    useEffect(() => {
      const init = async () => {
        const urls = JSON.parse(sessionStorage.getItem("urls") || "[]");
        const pages = await filterCompanyPages(urls);

        setFilteredPages(pages);

        const initialSelected = getInitialSelectedSiteMapUrls();
        setStoredSelected(initialSelected);
      };

      init();
    }, []);

    const selectedCount = useMemo(() => {
      return (storedSelected || []).filter((i) => i.checkedStatus).length;
    }, [storedSelected]);

    useEffect(() => {
      const handler = () => {
        const latest = getInitialSelectedSiteMapUrls();
        setStoredSelected(latest);
      };

      window.addEventListener("sitemapSelectionUpdated", handler);
      return () =>
        window.removeEventListener("sitemapSelectionUpdated", handler);
    }, []);

    return (
      <>
        <div className={styles.container} ref={listRef}>
          <form className={styles.formContainer} onSubmit={handleSubmit}>
            <div className={styles.form}>
              <div className={styles.labReq}>
                <div className={styles.formGroupurl}>
                  <label>Website (URL)</label>
                  <div className={styles.inputWrapper}>
                    <input
                      type="text"
                      placeholder="https://Designersx.us"
                      value={hasNoWebsite ? "" : website}
                      onChange={handleWebsiteChange}
                      onFocus={() => {
                        if (!website) {
                          setWebsite("https://");
                        }

                        // if (website) {
                        //   validateAndFetchSiteMap(website, null, { preserveSelection: true });
                        // }
                      }}
                      disabled={hasNoWebsite || validateLoading}
                    />
                    {website && !hasNoWebsite && (
                      <>
                        {validateLoading && (
                          <div
                            className={`newloader ${styles.checkIcon}`}
                          ></div>
                        )}

                        {!validateLoading && isValidWebsite === true && (
                          <img
                            src="/svg/check-icon.svg"
                            alt="check"
                            className={styles.checkIcon}
                          />
                        )}

                        {!validateLoading && isValidWebsite === false && (
                          <img
                            src="/svg/cross-icon.svg"
                            alt="cross"
                            className={styles.checkIcon}
                          />
                        )}
                      </>
                    )}
                  </div>
                </div>
                <div
                  className={styles.checkRowDiv}
                  style={{
                    position: "relative",
                    pointerEvents: validateLoading ? "none" : "auto",
                    opacity: validateLoading ? 0.6 : 1,
                  }}
                >
                  <div className={styles.checkboxRow}>
                    <input
                      type="checkbox"
                      id="nowebsite"
                      className={styles.checkbox}
                      checked={hasNoWebsite}
                      onChange={handleWebsiteCheckbox}
                    />
                    <label htmlFor="nowebsite" className={styles.newLable}>
                      I don't have a website
                    </label>
                  </div>

                  {website && isValidWebsite && !hasNoWebsite && (
                    <div className={styles.p12} onClick={handleOpenSiteMap}>
                      <p className={styles.p1} style={{ cursor: "pointer" }}>
                        {selectedCount} pages selected
                      </p>

                      <p className={styles.p2}>
                        {filteredPages ? filteredPages?.length : ""} pages found
                      </p>
                    </div>
                  )}
                </div>
                <div className={styles.formGroup}>
                  <label>
                    Business Name{" "}
                    <span className={styles.requiredStar1}>*</span>
                  </label>
                  <input
                    type="text"
                    value={businessName}
                    onChange={(e) => {
                      const value = e.target.value;
                      const noNumbersOrEmojis = value
                        .replace(/[0-9]/g, "") // remove digits
                        .replace(
                          /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF])/g,
                          ""
                        );
                      handleInputChange("businessName", noNumbersOrEmojis);
                      setTimeout(scrollListIntoView, 300);
                    }}
                    placeholder="Your Business Name"
                    required
                    maxLength={50}
                    onFocus={(e) => {
                      if (isIphone) {
                      } else {
                        setTimeout(scrollListIntoView, 300);
                      }
                    }}
                    onClick={(e) => {
                      if (isIphone) {
                      } else {
                        setTimeout(scrollListIntoView, 300);
                      }
                    }}
                  />{" "}
                </div>

                <div className={styles.formGroup}>
                  <label>
                    Phone Number <span className={styles.requiredStar1}>*</span>
                  </label>
                  <PhoneInput
                    country={selectedCountry}
                    value={phoneNumber}
                    onChange={(phone, countryData) => {
                      const fullPhone = phone.startsWith("+")
                        ? phone
                        : `+${phone}`;
                      setPhoneNumber(fullPhone);
                      setSelectedCountry(countryData?.countryCode || "us");
                      handleInputChange("phone", fullPhone);
                    }}
                    inputStyle={{
                      width: "100%",
                      height: "40px",
                      paddingLeft: "45px",
                      borderRadius: "5px",
                    }}
                    placeholder="+1 (123)456-7890"
                    required
                    onFocus={(e) => {
                      if (isIphone) {
                      } else {
                        setTimeout(scrollListIntoView, 300);
                      }
                    }}
                    onClick={(e) => {
                      if (isIphone) {
                      } else {
                        setTimeout(scrollListIntoView, 300);
                      }
                    }}
                  />
                </div>

                <div className={styles.formGroup}>
                  <label>
                    Address <span className={styles.requiredStar1}>*</span>
                  </label>
                  <GoogleAddressInputWithDropdown
                    value={address}
                    onChange={(val) => handleInputChange("address", val)}
                    scrollIntoView={scrollListIntoView}
                    listPosition="relative"
                    listPaddingRight="0px"
                    listMarginTop="0px"
                  />
                </div>

                <div className={styles.formGroup}>
                  <label>Business Email</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => handleInputChange("email", e.target.value)}
                    placeholder="Business Email Address"
                    onFocus={(e) => {
                      if (isIphone) {
                      } else {
                        setTimeout(scrollListIntoView, 300);
                      }
                    }}
                    onClick={(e) => {
                      if (isIphone) {
                      } else {
                        setTimeout(scrollListIntoView, 300);
                      }
                    }}
                  />
                </div>

                <div className={styles.formGroup}>
                  <label>About My Business</label>
                  <textarea
                    rows="3"
                    value={aboutBussiness}
                    onChange={(e) => {
                      const cleaned = sanitizeDescription(e.target.value);
                      handleInputChange("aboutBussiness", cleaned);
                    }}
                    onBlur={() => {
                      const finalText = (aboutBussiness || "")
                        .replace(/\s+/g, " ")
                        .trim();
                      handleInputChange("aboutBussiness", finalText);
                    }}
                    onPaste={(e) => {
                      e.preventDefault();
                      const paste = e.clipboardData.getData("text");
                      const cleaned = sanitizeDescription(paste);
                      const finalVal = sanitizeDescription(
                        (aboutBussiness || "") + " " + cleaned
                      );
                      handleInputChange("aboutBussiness", finalVal);
                    }}
                    placeholder="Describe"
                    maxLength={200}
                  />
                </div>
              </div>
            </div>
          </form>
          {showPopup && (
            <PopUp
              type={popupType}
              message={popupMessage}
              onClose={() => setPopupMessage("")}
            />
          )}
        </div>
      </>
    );
  }
);

export default BusinessListing;
